var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormStepper',{staticClass:"p-4 p-md-5",staticStyle:{"max-width":"1200px","line-height":"1.5em","font-size":"16px"},attrs:{"steps":_vm.steps,"formData":_vm.formData}})}
var staticRenderFns = []

export { render, staticRenderFns }